import gql from 'graphql-tag'

export const QUERY_GET_CAMPAIGN_BY_ID = gql`
  query Campaign($id: ID!) {
    campaign(_id: $id) {
      _id
      title
      status
      description
      initial_date
      final_date
      units {
        id_erp
        name
      }
      frequency {
        type
        interval
      }
      segments {
        _id
        name
        clients_qty
        updated_at
        clients_refreshed_at
        clients_qty_at_campaign
      }
      products {
        sku
        name
      }
      message {
        text
        send_date
        send_time
        ... on PushChannelCampaignMessage {
          title
          inner_message_title
          inner_message_text
        }
      }
      offers_schedule {
        _id
        name
        description
        segments
        end_date
        start_date
      }
      template_id

      ... on PushChannelCampaign {
        image_url
        targeting_mode
        action {
          type
          link
          reference_id
        }
      }
    }
  }
`

export const MUTATION_UPSERT_PUSH_CAMPAIGN = gql`
  mutation UpsertPushCampaign($data: PushChannelCampaignInput!) {
    upsertPushCampaign(data: $data) {
      _id
    }
  }
`

export const MUTATION_UPSERT_DRAFT_PUSH_CAMPAIGN = gql`
  mutation UpsertDraftPushCampaign($data: DraftPushChannelCampaignInput!) {
    upsertDraftPushCampaign(data: $data) {
      _id
    }
  }
`

export const QUERY_GET_RESULT_METRICS_PUSH_CAMPAIGN_BY_ID = gql`
  query Campaign($id: ID!) {
    campaign(_id: $id) {
      _id
      title
      status
      description
      initial_date
      final_date
      segments {
        _id
        name
        clients_qty
      }
      products {
        sku
        name
      }
      message {
        send_date
        send_time
        sendings {
          delivered
          clients
          total
          sent
          price
          credits
          text
          date
          time
        }
      }
      targeting_mode
      metrics {
        clients_metrics {
          received {
            count
            representation
          }
          opened {
            count
            representation
          }
          received_and_bought {
            count
            representation
            revenue
            average_ticket
            tickets
          }
          received_with_products {
            count
            representation
            revenue
            average_ticket
            tickets
          }
          received_with_only_products {
            count
            representation
            revenue
            average_ticket
            tickets
          }
        }
        products_metrics {
          totals {
            quantity
            revenue
            tickets
            clients
            representation
          }
          table {
            product {
              sku
              name
            }
            received {
              quantity
              revenue
              tickets
              clients
              representation
            }
          }
        }
        analytic_metrics {
          average_ticket_received_variation
        }
      }
    }
  }
`

export const QUERY_GET_CAMPAIGNS_COUNTS_PER_STATUS = gql`
  query CampaignsCountsPerStatus {
    campaignsCountsPerStatus(mode: PUSH) {
      ACTIVE
      SCHEDULED
    }
  }
`
